import { OnboardingIntentStep } from 'src/app/shared/enums/intent.enum';

export class Layout {
  header?: Header;
  sideMenu?: SideMenu;
  main?: Main;
  footer?: Footer;
}

export interface Header {
  simple?: boolean;
  logOutButton?: boolean;
  closeButton?: boolean;
  languageSelector?: boolean;
  hideMobileLogo?: boolean;
  bgTransparentMobile?: boolean;
  cancelIntent?: boolean;
  preventClickOnLogo?: boolean;
  skipLink?: {
    show: boolean;
    step: OnboardingIntentStep;
  };
}

export interface SideMenu {
  hide?: boolean;
  hasClass?: boolean; // has "has-side-menu" class in main and header even when side menu is not present or hidden
  relative?: boolean;
}

export interface Main {
  noPaddingBottom?: boolean;
  hasBgColor?: boolean;
}
export interface Footer {
  bottomOffset?: 'checkout' | 'product';
  hide?: boolean;
  hideMobileNav?: boolean;
}
